import { Logo } from '@components/icons/logo'
import { Container } from '@components/layout/grid'
import styles from '@components/playbook/pre-header/preheader.module.scss'

export const PreHeader = () => {
    return (
        <Container>
            <div className={styles.preHeader}>
                <Logo width='52' height='42' alt='Step logo' preset='color' />
            </div>
        </Container>
    )
}
